import { Marker } from 'mapbox-gl';

export default class mapMarker {
  #marker
  #pinElement

  constructor({ latitude, longitude }) {
    this.#marker = new Marker({
      color: '#d72027',
      scale: 1.25,
    })
      .setLngLat([longitude, latitude]);
    this.#pinElement = this.#marker.getElement();
  }

  on(event = 'click', fn) {
    this.#marker.getElement().addEventListener(event, e => fn(e));
  }

  getLngLat() {
    return this.#marker.getLngLat();
  }

  // eslint-disable-next-line class-methods-use-this
  removeHighlight() {
  }

  // eslint-disable-next-line class-methods-use-this
  highlight() {
  }

  getMarker() {
    return this.#marker;
  }
}
